export const mock = {
  company: {
    name: "Alianza Trinchero SRL",
    tagline: "Molienda y comercialización de minerales no metalíferos",
    subtagline:
      "Más de 50 años abasteciendo a la industria argentina con calidad y cumplimiento.",
    origin:
      "Fundada en 2025 a partir de la unión de Carlos Alberto Trinchero y Molinos Alianza SRL, ambas con más de 50 años de trayectoria en el mercado argentino.",
    locationShort: "Parque Industrial Lanús Este (CEPILE)",
    siteArea: "5.000 m²",
    coverage: "AMBA + alcance nacional",
    contact: {
      email: "alianzatrinchero@gmail.com",
      phoneFixedDisplay: "(011) 2134-1264",
      phoneMobileDisplay: "11-2382-7760",
      address:
        "Gervasio A de Posadas 775, Lanús Este, Provincia de Buenos Aires.",
    },
  },
  whatsapp: {
    phoneDigits: "541123827760",
    defaultMessage:
      "Hola, quisiera solicitar una cotización. Me interesa molienda/comercialización de minerales no metalíferos. ¿Podemos coordinar?",
  },
  infra: {
    bullets: [
      {
        title: "Planta propia en parque industrial",
        desc: "Operación estable, logística optimizada y respuesta rápida.",
      },
      {
        title: "Molinos industriales + almacenaje",
        desc: "Capacidad real para continuidad y plazos de entrega.",
      },
      {
        title: "Respuesta rápida al AMBA",
        desc: "Ubicación estratégica para abastecimiento regional.",
      },
      {
        title: "Cobertura nacional",
        desc: "Despachos a todo el país según requerimiento del cliente.",
      },
    ],
    stats: [
      { label: "Superficie", value: "5.000 m²" },
      { label: "Ubicación", value: "Lanús (AMBA)" },
      { label: "Trayectoria", value: "+50 años" },
      { label: "Enfoque", value: "B2B industrial" },
    ],
  },
  services: {
    products: {
      title: "Producción y comercialización",
      lead:
        "Minerales industriales con especificación clara, stock y continuidad de abastecimiento.",
      points: [
        "Amplia variedad de minerales no metalíferos",
        "Múltiples granulometrías",
        "Stock permanente",
        "Asesoramiento técnico para selección y especificación",
      ],
    },
    toll: {
      title: "Molienda y fasón a terceros",
      lead:
        "Servicio para terceros con enfoque en estabilidad de proceso, repetibilidad y cumplimiento.",
      equipment: [
        "Molinos a martillos",
        "Molino pendular",
        "Molino a bolas",
        "Moliendas especiales",
        "Clasificación por zarandas según especificación",
      ],
    },
  },
  minerals: [
    {
      name: "Arcillas y Caolines",
      tag: "Cerámica y refractarios",
      uses: "Industria de cerámica y porcelanas, refractarios, caucho y goma.",
      grades: ["#200"],
    },
    {
      name: "Barita / Celestina",
      tag: "Fricción y perforación",
      uses: "Elementos de fricción, cristalería (vidrio), perforaciones petroleras",
      grades: ["#10", "#30/80", "#200"],
    },
    {
      name: "Bentonita",
      tag: "Aditivos",
      uses: "Impermeabilizante, emulsionante, nutrición animal",
      grades: ["#200"],
    },
    {
      name: "Carbonato de Calcio",
      tag: "Carga mineral",
      uses:
        "Cristalería (vidrio), nutrición animal, caucho y goma, pinturas, membranas asfálticas",
      grades: ["#6/19", "1–10 mm", "#10", "#30/80", "#200", "#325"],
    },
    {
      name: "Cuarzo",
      tag: "Sílice",
      uses:
        "Abrasivos, construcción, pisos industriales, pinturas y revestimientos, detergentes, cerámica, cristalería, esmaltes vitrificables",
      grades: [
        "#4/8",
        "#8/20",
        "#20/40",
        "#30/80",
        "#40/100",
        "#100",
        "#200",
        "#325",
      ],
    },
    {
      name: "Dolomita",
      tag: "Carbonatos",
      uses:
        "Pinturas y revestimientos, caucho y goma, cristalería, nutrición animal",
      grades: [
        "#0/00",
        "#0/1",
        "Alfiler (1 mm)",
        "#20/80",
        "#60/80",
        "#80",
        "#120",
        "#200",
        "#325",
        "#400",
        "#600",
      ],
    },
    {
      name: "Feldespato Potásico",
      tag: "Fundentes",
      uses: "Cristalería, esmaltes vitrificables, cerámica",
      grades: ["#30/80", "#200"],
    },
    {
      name: "Feldespato Sódico",
      tag: "Fundentes",
      uses: "Cristalería, esmaltes vitrificables, cerámica",
      grades: ["#200"],
    },
    {
      name: "Fluorita",
      tag: "Siderurgia",
      uses: "Fundente, siderurgia",
      grades: ["#10", "#30/80"],
    },
    {
      name: "Mica",
      tag: "Escamas",
      uses: "Pinturas y revestimientos, cerámica",
      grades: ["Escamas", "#30/80", "#200"],
    },
    {
      name: "Sulfato de Calcio (Yeso)",
      tag: "Enmienda",
      uses: "Cristalería, enmienda agrícola",
      grades: ["#30/80"],
    },
    {
      name: "Talco Industrial",
      tag: "Fricción",
      uses: "Elementos de fricción, pinturas y revestimientos",
      grades: ["#200"],
    },
    {
      name: "Tiza",
      tag: "Caucho y goma",
      uses: "Caucho y goma",
      grades: ["#200", "#325"],
    },
    {
      name: "Zeolita",
      tag: "Nutrición / agua",
      uses:
        "Suplementación en nutrición animal, purificador de agua, enmienda agrícola",
      grades: ["1–3 mm", "2-4mm", "#200"],
    },
    {
      name: "Otros minerales industriales",
      tag: "A medida",
      uses: "Consultanos por disponibilidad y especificación",
      grades: [],
    },
  ],
  mineralsNote:
    "Granulometrías desde tamaños milimétricos hasta micronizados, según necesidad del cliente.",
  industries: [
    "Vidrio",
    "Cerámica (sanitarios y vajilla)",
    "Siderurgia",
    "Pinturas y revestimientos",
    "Caucho y goma",
    "Nutrición animal",
    "Plástica",
    "Esmaltes",
  ],
  differentiators: [
    {
      title: "Más de 50 años de trayectoria",
      desc: "Experiencia acumulada en molienda y abastecimiento industrial en Argentina.",
    },
    {
      title: "Control de calidad en proceso",
      desc: "Seguimiento de variables clave para cumplir con especificación.",
    },
    {
      title: "Asesoramiento técnico personalizado",
      desc: "Te ayudamos a definir granulometría y producto según aplicación.",
    },
    {
      title: "Cumplimiento en plazos",
      desc: "Organización operativa orientada a continuidad de entrega.",
    },
    {
      title: "Ubicación estratégica en AMBA",
      desc: "Logística eficiente para clientes del área metropolitana.",
    },
  ],
  faqs: [
    {
      q: "¿Qué rango de granulometrías trabajan?",
      a: "Desde tamaños milimétricos hasta micronizados, según mineral y requerimiento. Podemos conversar la especificación y el objetivo de aplicación para recomendar el mejor esquema de molienda/clasificación.",
    },
    {
      q: "¿Realizan servicio de fasón con materia prima del cliente?",
      a: "Sí. Trabajamos molienda a terceros (fasón) y podemos acordar recepción, molienda, clasificación por zarandas y entrega según el protocolo definido.",
    },
    {
      q: "¿Cómo se coordinan plazos y entregas?",
      a: "Se acuerdan por volumen, especificación, disponibilidad y logística. Nuestra ubicación en AMBA permite respuesta rápida regional y despachos al interior.",
    },
    {
      q: "¿Qué información necesitan para cotizar?",
      a: "Mineral, granulometría objetivo (o aplicación), volumen mensual/por pedido, formato de entrega y ubicación de destino. Si no tenés todo definido, te asesoramos para completar la especificación.",
    },
  ],
};

export function buildWhatsAppUrl({ phoneDigits, message }) {
  const safeDigits = (phoneDigits || "").replace(/\D/g, "");
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${safeDigits}?text=${text}`;
}
